import self1 from "../img/self1.png";
import mock1 from "../img/mock1.png";
import mock2 from "../img/mock2.png";

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */

/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
  firstName: "Savindu",
  lastName: "Pasintha",
  initials: "*", //'React+Js+Java+C# ..', // the example uses first and last, but feel free to use three or more if you like.
  positionTop: "Frontend Engineering | Fullstack Engineering",
  position: "Fullstack AI Software Engineer",
  subPosition: "",
  selfPortrait: self1, // don't change this unless you want to name your self-portrait in the "img" folder something else!
  gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
  baseColor: colors[0],
  miniBio: [
    // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
    {
      emoji: "🌎",
      text: "Open to work",
    },
    // {
    //   emoji: '💼',
    //   text: '',
    // },

    {
      emoji: "☕",
      text: "fueled by coffee",
    },
    {
      emoji: "📧",
      text: (
        <a href="mailto:savindupasingtha@gmail.com">
          savindupasingtha@gmail.com
        </a>
      ),
    },
  ],
  socials: [
    {
      link: "https://www.linkedin.com/in/savindu-pasintha/",
      icon: "fa fa-linkedin",
      label: "linkedin",
    },
    {
      link: "https://github.com/savindu-pasintha",
      icon: "fa fa-github",
      label: "github",
      count: "122",
    },
    {
      link: "https://savindupasingtha.medium.com",
      icon: "fa fa-medium",
      label: "medium",
    },
    {
      link: "https://stackoverflow.com/users/15484152/savindu-pasintha",
      icon: "fa fa-stack-overflow",
      label: "stackpverflow",
    },

    /* {
      link: 'https://facebook.com',
      icon: 'fa fa-facebook',
      label: 'facebook',
    },
    {
      link: 'https://instagram.com',
      icon: 'fa fa-instagram',
      label: 'instagram',
    },

    {
      link: 'https://twitter.com',
      icon: 'fa fa-twitter',
      label: 'twitter',
    },
    */
    // Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
    // Just change the links so that they lead to your social profiles.
  ],
  bio: `With 8.5 years of experience as a Software Engineer, I specialize in Frontend development with expertise in technologies such as JavaScript, TypeScript, React.js, HTML5, CSS3, SASS, Bootstrap, Node, Next, Gatsby js. My experience spans diverse industries, including e-commerce, telecommunications, banking & DeFi, healthcare, apparel, and petroleum vessel shipping. Proficient in the full Software Development Life Cycle (SDLC) and Agile methodologies, I have a proven track record of delivering innovative, responsive, and user-centric interfaces. Additionally, I am skilled in leveraging AWS cloud services, including AWS Lambda, S3, EC2, and API Gateway, to enhance application performance and scalability. Known for my strong problem-solving abilities, attention to detail, and ability to work effectively in multicultural environments, I am committed to delivering high-performance, scalable, and secure frontend solutions in all projects.`,
  skills: {
    coding: [
      "🌱 JavaScript",
      "🌱 Typescript",
      "🌱 Java",
      "🌱 C#",
      " 🌱 C++",
      "🌱 Dart",
      "🌱 Kotlin ",
      "🌱 PHP",
      "🌱 Python",
      "🌱 Go",
      "🌱 Solidity",
    ],
    ai: [
      "Large Language Models (LLMs)",
      "RAG (Retrieval-Augmented Generation)",
      "LangChain",
      "LangGraph",
      "Prompt Engineering",
      "OpenAI API",
      "Gemini API",
      "Agentic AI Workflows",
      "Vector Databases",
      "Databricks",
      "Azure AI Search",
    ],
    backend: [
      "NodeJs",
      "Express",
      "Springboot",
      ".Net Core",
      "Django",
      "Go",
      "GraphQL",
      " Elastic Search",
      "Socket.io ",
      "Web-Sockets",
      "REST API Integration",
      "JWT",
      "OAuth",
      "OpenID",
      "OpenTelemetry",
      "Redis Caching",
      "PostgreSQL",
    ],
    frontend: [
      "Reactjs",
      " Nextjs",
      " Vuejs",
      " Electronjs",
      " Qt",
      "Micro-Frontend (Module Federation)",
      "Tailwind CSS",
      "Redux / Redux Toolkit",
      "React Hooks",
      "Figma-UI",
      "Adobe-UI",
      "HTML",
      "CSS",
      "SCSS",
      "Bootstrap",
      "JQuery",
      "Material-Design",
      "Ant-Design",
      "WordPress",
      "SEO",
      "Block-Chain",
      "Cripto",
      "web3",
      "Metamask",
      "Angular",
    ],
    mobile: ["Android", "Java", "Kotlin", "React-Native", "Dart", "Flutter"],
    desktop: ["C++ QT Framework", "C# .NET Framework", "Java "],
    database: ["SQL", "MySql", "SqlLite", "MongoDB", "Firebase ", "Nosql"],
    cloud: [
      "AWS",
      "AZURE",
      "Google Cloud",
      "AWS EC2",
      "AWS Lambda",
      "AWS Elastic Beanstalk",
      "AWS ECS",
      "AWS EKS",
      "AWS S3",
      "AWS EBS",
      "AWS Glacier",
      "AWS FSx",
      "AWS RDS",
      "AWS DynamoDB",
      "AWS Redshift",
      "AWS Aurora",
      "AWS VPC",
      "AWS Route 53",
      "AWS CloudFront",
      "AWS Direct Connect",
      "AWS IAM",
      "AWS KMS",
      "AWS WAF",
      "AWS Shield",
      "AWS Security Hub",
      "AWS Athena",
      "AWS QuickSight",
      "AWS EMR",
      "AWS Glue",
      "AWS SageMaker",
      "AWS Lex",
      "AWS Polly",
      "AWS Rekognition",
      "AWS CloudFormation",
      "AWS CloudWatch",
      "AWS CodePipeline",
      "AWS Step Functions",
      "AWS EventBridge",
      "AWS Outposts",
      "AWS Wavelength",
      "Microsoft Azure",
      "Azure VMs",
      "Azure Blob Storage",
      "Azure Functions",
      "AKS",
      "Google Cloud Platform",
      "GCP Compute Engine",
      "GCP Cloud Functions",
      "BigQuery",
      "IBM Cloud",
      "Watson AI",
      "IBM Cloud Kubernetes Service",
      "Oracle Cloud",
      "OCI Compute",
      "Autonomous Database",
      "Alibaba Cloud",
      "Alibaba ECS",
      "Alibaba OSS",
      "Alibaba Cloud CDN",
      "Docker",
      "Kubernetes",
      "OpenShift",
      "Jenkins",
      "GitHub Actions",
      "GitLab CI/CD",
      "Terraform",
      "Ansible",
      "Pulumi",
      "Prometheus",
      "Grafana",
      "Datadog",
      "HashiCorp Vault",
      "Okta",
      "Sumo Logic",
    ],
    proficientWith: [
      "javascript",
      "react",
      "git",
      "github",
      "bootstrap",
      "html5",
      "css3",
      "figma",
    ],
    exposedTo: ["nodejs", "python", "adobe illustrator"],
  },
  hobbies: [
    {
      label: "programing",
      emoji: "📖",
    },
    {
      label: "researching new technologies",
      emoji: "🎭",
    },
    {
      label: "self learning",
      emoji: "🎥",
    },
    {
      label: "designing",
      emoji: "🌶",
    },
    {
      label: "traveling",
      emoji: "🎭",
    },
    {
      label: "freedom",
      emoji: "🎥",
    },
    {
      label: "cooking",
      emoji: "🌶",
    },
    // Same as above, change the emojis to match / relate to your hobbies or interests.
    // You can also remove the emojis if you'd like, I just think they look cute :P
  ],
  education: [
    {
      id: 1,
      what: "BSC(Hons) Computing & Software Engineering",
      where: "Cardiff Metropolitan, University, Uk",
      time: " 2019",
      grade: "1'st Class",
    },
    {
      id: 2,
      what: "Higher National Diploma in Computing & Software Engineering",
      where: "International College Of Business & Technology, Sri Lanka",
      time: " 2019",
      grade: "1'st Class",
    },
    {
      id: 3,
      what: "Certificate In Computer Hardware & Network",
      where:
        "Foundation of Goodness OYOB Centre of Excellence, Sinigama , Sri Lanka",
      time: "Jan 2019 - July 2019 ",
      grade: "",
    },
    {
      id: 4,
      what: "High School (GCE Advanced Level(GCE A/L))",
      where: "National School, Ananada Sastralaya, Mathugama, Sri Lanaka",
      time: "2015 - August 2018",
      grade: `Physical Science Stream  (Physics/Combine Maths/Chemistry)`,
    },
    {
      id: 5,
      what: "Primary School (GCE Ordinary Level(GCE O/L))",
      where: "National School, Ananada Sastralaya, Mathugama, Sri Lanaka",
      time: "2010 - 2015",
      grade: `8A & 1B`,
    },
  ],
  workHistory: [
    {
      id: 8,
      role: "Fullstack AI Software Engineer ( AI )",
      company: "Singtel Tele-Communication (PRIVATE) LIMITED",
      location: "Singapore",
      time: "Aug 2025 – Present",
      summery: `<h6>
        <span>Responsibilities</span>
        <li>Designed and developed an AI-driven Sales Recommendation Application (AISA) to suggest personalized Singtel products for customers using LLMs, RAG, and prompt engineering techniques.</li>
        <li>Implemented backend services using Expressjs, Python (Flask) with Redis caching and PostgreSQL for scalable data handling.</li>
        <li>Integrated LangChain, LangGraph, and OpenTelemetry, OpenAI/Gemini models to build conversational and context-aware AI assistants with agentic UI workflows.</li>
        <li>Developed and fine-tuned prompt optimization strategies to enhance response accuracy, reduce latency, and improve user engagement.</li>
        <li>Built the frontend in Next.js and React, Microfrontend (Module Federation) with Redux for state management, ensuring responsive and dynamic user experiences.</li>
        <li>Deployed applications on AWS Cloud using Helm charts and Bamboo CI/CD pipelines, enabling efficient continuous delivery and observability.</li>
        <li>Collaborated cross-functionally using Jira for agile sprint tracking and issue management.</li>
        <li>Improved AI reasoning and user recommendation accuracy by iteratively refining system prompts and RAG pipeline performance.</li>
</h6>
`,
    },
    {
      id: 7,
      role: "Software Engineer ( Frontend )",
      company: "Luxoft Information Technology Pte Ltd(for OCBC Bank Singapore)",
      location: "Singapore",
      time: "Sep 2024 – March 2025",
      summery: `<h6>
    <span>Responsibilities</span>  
    <li>Redesigned and developed the OCBC Bank Internal Application (GM Workbench Bank Trading DeFi Blockchain Dashboard), focusing on banking treasury products trading, on-chain transaction tracking, and decentralized financial data visualization.</li>
    <li>Designed a responsive and user-friendly interface, ensuring a performance-optimized application by following React best practices, while integrating smart contract interactions using ReactJS, HTML5, CSS3, Material-UI, Webpack, NPM, Node.js, and micro frontend architecture.</li>
    <li>Developed scalable frontend designs and integrated them with Java Spring Boot and Node.js microservices, implementing RESTful APIs and WebSockets.</li>
    <li>Ensured adherence to industry standards and best practices, including blockchain frontend security.</li>
    <li>Conducted SIT, UAT, Production, and end-to-end system testing, ensuring high-quality deliverables and seamless production rollouts using CI/CD pipelines (Git, Jenkins, Red Hat on AWS Cloud, Nexus, SonarQube, Jest, and Cypress).</li>
    <li>Performed code reviews, ensured adherence to best practices, and facilitated efficient merging of pull requests, maintaining code quality, security, and performance standards.</li>
    <li>Maintained accurate and up-to-date technical documentation, flow diagrams, and system documentation.</li>
    <li>Investigated and resolved reported system errors, ensured optimal system functionality, and maintained technical documentation.</li>
    <li>Ensured compliance with financial sector security and regulatory guidelines (MAS, FATF, GDPR).</li>
    <li>Mentored a team of 3 developers across onsite (Singapore) and offshore (China), ensuring efficient collaboration and timely delivery of project milestones.</li>
</h6>
`,
    },
    {
      id: 0,
      role: "Software Engineer",
      company: "Singtel Tele-Communication (PRIVATE) LIMITED",
      location: "Singapore",
      time: "Aug 2023 – Aug 2024",
      summery: `<h6>
        <span>Responsibilities</span>
        <li>Coordinated module specifications analysis and development progress tracking to ensure timely and efficient project completion.</li>
        <li>Established and enforced industry-standard programming guidelines, best practices, and integration mechanics within the team.</li>
        <li>Managed configuration changes, including hardware, software, and documentation, through comprehensive configuration management planning and audits.</li>
        <li>Reviewed unit and SIT test scenarios, conducted tests, and documented results to maintain high program quality standards.</li>
        <li>Facilitated SIT test case closure and tracked module delivery from development to SIT.</li>
        <li>Conducted thorough end-to-end integration and system testing.</li>
        <li>Provided support during User Acceptance Testing (UAT) and implementation, addressing and resolving system issues for smooth production (CI/CD pipelines) execution.</li>
        <li>Investigated and resolved reported system problems/errors, ensuring optimal system functionality.</li>
        <li>Maintained accurate and up-to-date technical documentation, flow diagrams, and system documentation.</li>
        <li>Translated functional requirements into React.js Frontend, Node.js Microservice application designs and worked with AWS Cloud services, adhering to established design methodologies and guidelines.</li>
        <li>Conducted code reviews ensuring compliance with financial sector security guidelines.</li>
        <li>Effectively managed a team of 4-5 developers both onsite and offshore, ensuring collaborative and productive work environments.</li>
    
</h6>
`,
    },
    {
      id: 1,
      role: "Software Engineer",
      company: "X.O CONCEPTS (PRIVATE) LIMITED",
      location: "No 30/81- 1/1 ,Longdon Place , Colombo 07 , Sri Lanka.",
      time: "Jun 2022 – Jun 2023",
      summery: `<h6>
        <span>Responsibilities</span>
        <li>Developed & maintained React Micro Frontend based 'Auriga', 'Milora', 'Morex' Industrial Machine Management & Data Visualization dashboards, Java Spring Boot Jasper report POC, and was involved in developing Machine Learning Defect Detection & Labeling Applications with QT, C++ & Python.</li>
        <li>Worked with databases such as MySQL and MongoDB, and Restful APIs integration using React.js, JavaScript Axios, Redux, Json, jQuery, Java, C++, Node.js, Vite, Vitest, Express, Spring Boot, Junit, GitLab Pipelines, Jenkins, Jira, AWS, JWT, and Docker.</li>
        <li>Team Management, Code Review, Optimize code & Application performance.</li>
   
</h6>
`,
    },
    {
      id: 2,
      role: "Software Developer (Remote)",
      company: "Natobotics Technologies Pvt Ltd.",
      location:
        "#1206, 12th Floor, D-South Block, Tidel Park, Rajiv Gandhi Salai, Taramani, Chennai 600 113, india",
      time: "Jan 2021– Dec 2022",
      summery: `<h6>
        <span>Responsibilities</span>
        <li>Developed and maintained Beat Healthcare, Veritas petroleum management React.js Microfrontend application and web scraping applications.</li>
        <li>Worked with ANT UI Design, styled components, Charts, and ensured web page responsiveness with Bootstrap and media queries, UI testing with Jest, and API testing with Postman.</li>
        <li>Integrated C# Restful web APIs, WebSockets with MongoDB, MySQL, Express-Node.js, Bitbucket, Jenkins, and provided backend development and maintenance support.</li>
    
</h6>
`,
    },
    {
      id: 3,
      role: "Associate Software Engineer",
      company: "Nvision IT Solutions (PVT) Limited",
      location: "10 Kumarage Watta Road, Sri Jayawardenepura Kotte,Sri Lanka",
      time: "Jan 2019 – Dec 2020",
      summery: `<h6>
        <span>Responsibilities</span>
        <li>Develop and maintain Sales Play POS web/mobile application, C#, .NET-based Thermal Printer desktop applications.</li>
        <li>Gained experience in Angular, React.js lifecycle, and React Native & mobile app development.</li>
        <li>Managed challenging work schedules to deliver software solutions to clients on time and within budget.</li>
        <li>Skilled in UI/UX design and converting designs into functional code.</li>
        <li>Collaborated with clients for requirement gathering and ensured timely product delivery.</li>
        <li>Proficient in Git, Jenkins, AWS, and RESTful API integration.</li>
    
</h6>
`,
    },
    {
      id: 4,
      role: "Associate DevOPS Engineer",
      company: "Global Wavenet International Pvt Ltd , Singappore",
      time: "",
      location: "",
      summery:
        "<h6> <span>Responsibilities</span><li> USSD & IVR(Interact voice response) Systems Development AWS / NodeJs / Javascript / kapanga Tool / System Design / Machine Learning / gitbucket </li> </h6>",
    },
    {
      id: 5,
      role: "Software Developer",
      company: "Upwork.com & Fiver.com",
      location: "",
      time: "2018 - 2019",
      summery: `<h6> 
        <span>Responsibilities</span>
        <li> Full stack web & mobile applications development & Mobile app reverse engineering </li> </h6>`,
    },
  ],
  portfolio: [
    {
      id: 8,
      title: "AISA (Artificial Intelligence Shopping Assistant) - Singtel",
      summery: `
      <p>AISA (Artificial Intelligence Shopping Assistant) is a cutting-edge, AI-powered sales engine that revolutionizes how Singtel customers discover and purchase products. Built as a high-performance **Next.js Single Page Application (SPA)**, it provides a seamless shopping experience for Sim-only plans, Fibre broadband, and the latest mobile accessories.</p>
      <ul>
        <li><strong>Next.js SPA Frontend:</strong> Developed a highly responsive, single-page application focused on high conversion and optimal user experience.</li>
        <li><strong>Python Flask Backend:</strong> Engineered a robust backend using Python (Flask) with **LangChain** and **Swarm** for complex AI logic and distributed **microservice architecture**.</li>
        <li><strong>Advanced AI Orchestration:</strong> Implemented sophisticated AI techniques including **swarm-based agentic workflows**, **LangGraph**, and **supervision-based LLM architectures** to handle complex customer queries.</li>
        <li><strong>Deep Tracing & Observability:</strong> Comprehensive AI lifecycle tracing using OpenTelemetry and LangChain tracing to monitor model reasoning, latency, and token usage in real-time.</li>
        <li><strong>Performance & Scalability:</strong> Optimized the RAG pipeline and system prompts to enhance response accuracy while utilizing Redis caching for sub-second response times.</li>
        <li><strong>Infrastructure & Delivery:</strong> Deployed on AWS Cloud using Helm charts and Bamboo CI/CD pipelines, ensuring efficient continuous delivery and system resilience.</li>
        <li><strong>Business Success:</strong> Currently driving significant revenue growth with monthly sales exceeding $10,000 and consistently selling over 100 plans per month.</li>
      </ul>
      `,
      technologies: [
        "LLMs (OpenAI/Gemini)", "Python (Flask)", "LangChain", "Swarm (Agentic AI)", "LangGraph", 
        "Supervision-based AI", "Next.js (SPA)", "React.js", "Redux", "Tracing & Observability",
        "Microservices Architecture", "Redis Caching", "PostgreSQL", "Prompt Engineering", "RAG",
        "Databricks", "Azure AI Search",
        "OpenTelemetry", "AWS Cloud", "Helm Charts", "Bamboo CI/CD", "Jira", "Tailwind CSS"
      ],
      usedModules: ["Next.js (SPA)", "Python Flask", "LangChain", "Swarm", "Microservices"],
      live: "https://www.singtel.com/aisa",
      source: "",
      image: "mock2",
      imagesUrl: []
    },
    {
      id: 9,
      title: "Digispace - Internal All Application Management Dashboard - Singtel",
      summery: `
      <p>Digispace serves as the mission-control hub for Singtel's internal application ecosystem. It is a sophisticated, high-performance dashboard that centralizes application management, operational monitoring, and service orchestration into a single, intuitive interface. Recently evolved into an **AI Marketplace**, it now provides a complete ecosystem for AI-driven internal tools.</p>
      <ul>
        <li><strong>AI Marketplace:</strong> A central repository for discovering and deploying internal AI tools, featuring specialized workflows and model management.</li>
        <li><strong>Multi-Agent Systems:</strong> Orchestrates multiple autonomous AI agents to collaborate on complex internal tasks, leveraging advanced agentic architectures.</li>
        <li><strong>Conversational Analytics:</strong> Integrated AI-driven chat interfaces with deep analytics and conversation history tracking for internal support and operations.</li>
        <li><strong>Advanced Observability:</strong> Real-time monitoring of AI model performance, latency, and token usage, ensuring high reliability of the internal AI ecosystem.</li>
        <li><strong>MCP (Model Context Protocol) Integration:</strong> Pioneers the use of MCP to provide AI agents with secure, standardized access to internal Singtel data and toolsets.</li>
        <li><strong>Prompt Engineering Hub:</strong> Centralized playground for designing, testing, and versioning system prompts across all internal AI applications.</li>
        <li><strong>Microfrontend Excellence:</strong> Implemented using Module Federation, allowing different teams to deploy independent AI modules without affecting the core dashboard.</li>
        <li><strong>Centralized Orchestration:</strong> Provides a unified management layer for dozens of internal services, improving administrative efficiency using Next.js and React.</li>
        <li><strong>Real-time Monitoring:</strong> Features advanced data visualization and live status tracking for critical internal services.</li>
        <li><strong>Enterprise State Management:</strong> Utilizes a complex Redux / Redux Toolkit architecture to maintain consistent state across multiple shared micro-applications.</li>
      </ul>
      `,
      technologies: [
        "LLMs", "Multi-Agent Systems", "MCP (Model Context Protocol)", "AI Marketplace", 
        "Conversational AI", "Prompt Engineering", "Data Analytics", "Databricks", "Azure AI Search",
        "Next.js", "React.js", "Redux Toolkit", "Microfrontend (Module Federation)", 
        "Node.js", "Express", "RESTful APIs", "AWS Cloud", "OpenTelemetry", 
        "Bamboo CI/CD", "Helm", "Docker", "Jira", "Agile"
      ],
      usedModules: ["Microfrontend", "Next.js", "Redux", "AWS"],
      live: "",
      source: "",
      image: "mock2",
      imagesUrl: []
    },
    {
      id: 6,
      title: "Trading Dashboard and Real-time Cryptocurrency Monitoring",
      summery: `<ul>
      <li> <strong>APIs Integrated:</strong> I utilized Binance, CoinMarketCap, and CoinGecko APIs to pull real-time cryptocurrency data and pricing information.</li>
      <li> <strong>Real-Time Data Updates:</strong> WebSockets were implemented to deliver real-time price updates for cryptocurrencies, ensuring users receive the most current data without needing to refresh the page.</li>
      <li><strong>Data Visualization:</strong> I incorporated real-time charting libraries like Chart.js, TradingView, and D3.js to visualize market data in an easy-to-read, interactive manner, enhancing the user experience for crypto traders.</li>
      <li><strong>Frontend Development:</strong> The frontend was built using React, TypeScript, and JavaScript. React's component-based structure enabled efficient rendering of the live data with minimal re-renders.</li>
      <li><strong>State Management:</strong> Redux was used to manage application state, providing centralized data storage and ensuring smooth updates to the UI based on real-time changes.</li>
      <li><strong>Backend Development:</strong> The backend was built with Node.js, which communicates with the APIs, processes the data, and serves it to the frontend through RESTful APIs.</li>
      <li><strong>Responsive Design:</strong> The application is fully responsive, ensuring accessibility and usability across different devices, from desktop to mobile.</li>
      <li><strong>Authentication & Authorization:</strong> Implemented user authentication and role-based access controls to allow users to securely sign in and personalize their experience on the platform.</li>
      <li><strong>Cloud Hosting:</strong> Deployed the application on cloud platforms such as AWS, ensuring scalability and availability during peak traffic.</li>
      <li><strong>Real-time Communication:</strong> WebSocket connections were used for bidirectional real-time communication between the frontend and backend for seamless market price updates.</li>
      <li><strong>Error Handling:</strong> Used libraries like Sentry and React Error Boundaries for effective error tracking and graceful error handling in the production environment.</li>
      <li><strong>Optimization:</strong> Utilized tools like Webpack, Babel, and ESLint to optimize code, bundle assets, and maintain a high-quality codebase with proper linting.</li>
      <li><strong>Testing:</strong> The application uses Jest, Mocha, and Cypress for unit and end-to-end testing to ensure a bug-free, production-ready system.</li>
      <li><strong>Performance Monitoring:</strong> Integrated performance monitoring tools like Lighthouse and React Profiler to optimize the performance and load times of the application.</li>
      <li><strong>Custom Hooks:</strong> Built reusable custom React hooks for handling WebSocket connections, data fetching, and managing the application’s state.</li>
      <li><strong>Code Reusability:</strong> Followed DRY principles (Don’t Repeat Yourself) for code reusability and maintainability, especially for common components like chart visualizations, forms, and authentication logic.</li>
      <li><strong>Version Control:</strong> Used Git for version control and GitHub for code repositories and collaboration with the development team.</li>
      <li><strong>CI/CD:</strong> Integrated Jenkins for continuous integration and deployment (CI/CD) pipelines, automating the build, test, and deployment process.</li>
      <li><strong>Component Libraries:</strong> Used Material-UI and Ant Design for building beautiful, consistent, and responsive UI components.</li>
      <li><strong>Security:</strong> Ensured security practices like HTTPS, JWT Authentication, and OAuth to secure sensitive user information and prevent vulnerabilities.</li>
      <li><strong>Environment Variables:</strong> Utilized environment variables to store sensitive information securely in the application’s configuration (using tools like dotenv and React’s environment variable system).</li>
      <li><strong>API Integrations:</strong> Seamlessly integrated various APIs (Binance, CoinMarketCap, CoinGecko) for pulling real-time data and storing it in Redux for centralized state management.</li>
      <li><strong>WebSocket Libraries:</strong> Utilized libraries like Socket.IO and ws to manage real-time WebSocket connections and keep data synchronized across the platform.</li>
      <li><strong>Async Data Handling:</strong> Applied async/await and Promise-based architecture for managing asynchronous tasks in the application, such as data fetching and processing.</li>
      <li><strong>Server-Side Rendering (SSR):</strong> Used Next.js for SSR capabilities to improve SEO and ensure faster loading times for critical content.</li>
      <li><strong>Static Site Generation (SSG):</strong> Used Gatsby for static site generation to deliver pre-rendered, fast-loading pages, ensuring a smooth user experience.</li>
      <li><strong>Progressive Web App (PWA):</strong> Implemented PWA best practices to provide offline capabilities and improve the overall performance and accessibility of the application.</li>
      <li><strong>API Gateway:</strong> Utilized AWS API Gateway to manage APIs and integrate them with other AWS services for a seamless architecture.</li>
      <li><strong>Logging & Monitoring:</strong> Integrated tools like LogRocket and AWS CloudWatch to monitor app performance, track errors, and gain insights into user behavior.</li>
      <li><strong>Code Splitting:</strong> Leveraged React’s code-splitting features to reduce the size of JavaScript bundles and improve the app’s initial load performance.</li>
      <li><strong>WebSocket Authentication:</strong> Implemented token-based authentication for WebSocket connections to ensure secure and authorized communication.</li>
      <li><strong>Responsive Layouts:</strong> Built layouts using CSS Grid, Flexbox, and media queries to ensure compatibility across different screen sizes and devices.</li>
      <li><strong>Real-time Notifications:</strong> Implemented real-time notifications for price changes, new transactions, and other important events using WebSockets.</li>
      <li><strong>Mobile-First Design:</strong> Prioritized mobile-first design for optimal viewing and interaction on mobile devices, ensuring accessibility for all users.</li>
      <li><strong>Internationalization (i18n):</strong> Enabled internationalization support for multi-language support in global markets using libraries like react-i18next.</li>
    </ul>
  `,
      technologies: [
        "React",
        "TypeScript",
        "JavaScript",
        "Node.js",
        "WebSockets",
        "Chart.js",
        "TradingView",
        "Redux",
        "AWS",
        "RESTful APIs",
        "JWT Authentication",
        "Socket.IO",
        "Mocha",
        "Cypress",
        "Git",
        "GitHub",
        "Jenkins",
        "Material-UI",
        "Ant Design",
        "Lighthouse",
        "Webpack",
        "Babel",
        "ESLint",
        "Next.js",
        "Gatsby",
        "dotenv",
        "React Profiler",
        "LogRocket",
        "CloudWatch",
        "react-i18next",
        "react-router-dom",
        "Redux-Saga",
        "React-Query",
        "Formik",
        "Jest",
        "React Testing Library",
        "React Spring",
        "React-Bootstrap",
        "Styled-Components",
        "Framer Motion",
        "Axios",
        "GraphQL",
        "Apollo Client",
        "React-Redux-Firebase",
        "React-DnD",
        "Tailwind CSS",
        "Figma",
        "Storybook",
        "Prettier",
        "Vercel",
        "Heroku",
        "Nginx",
        "PWA (Progressive Web App)",
        "Redux Thunk",
        "React Helmet",
        "React Table",
        "React Select",
        "Redux DevTools",
      ],
      usedModules: [
        "Binance API",
        "CoinMarketCap API",
        "CoinGecko API",
        "React Hooks",
        "Redux",
        "Chart.js",
        "TradingView",
        "Socket.IO",
        "Material-UI",
        "Ant Design",
        "React-Query",
        "Axios",
        "Apollo Client",
        "React Spring",
        "Formik",
        "Jest",
        "React Testing Library",
        "Tailwind CSS",
        "GraphQL",
        "Firebase",
        "React-DnD",
        "Prettier",
        "Storybook",
        "Vercel",
        "Heroku",
        "Nginx",
        "PWA",
        "React Table",
      ],
      live: "",
      source: "",
      image: mock2,
      imagesUrl: [
        "/assests/img/projects/trade/1.mp4",
        "/assests/img/projects/trade/2.mp4",
        "/assests/img/projects/trade/3.mp4",
      ],
    },
    {
      id: 1,
      title:
        "OCBC Bank Internal Application (GM Workbench Bank Trading DeFi Blockchain Dashboard) (OCBC Bank)",
      summery: `
      <p> Redesigned and developed the OCBC Bank Internal Application (GM Workbench Bank Trading DeFi Blockchain Dashboard), focusing on banking treasury products trading, on-chain transaction tracking, and decentralized financial data visualization. Designed a responsive and user-friendly interface that ensures a performance-optimized application for creating trading booking forms, reversing trades, and visualizing real-time financial transaction data for various products, including Certificates of Deposit (CDs), Collateralized Loan Obligations (CLOs), Collateralized Debt Obligations (CDOs), Credit Linked Notes (CLN), Bank Certificates of Investment (BCI), Bank Credit Notes (BCN), Foreign Exchange (FX), Interest Rate Swaps (IRS), Treasury Bills (T-Bills), Treasury Bonds, Futures and Options, Derivatives (Swaps, Forwards, Options, Futures), Structured Notes, Cross-Currency Swaps, Credit Default Swaps (CDS), Repurchase Agreements (Repos), Foreign Currency Investment (FCI), and Foreign Currency Notes (FCN).
Contributed to the development and redesign of a ReactJS-based micro frontend application with Material-UI and Quinkun, leveraging Webpack for efficient bundling. Integrated data between the Java microservices backend and the frontend, ensuring seamless functionality. Streamlined the development and deployment processes using Bitbucket, Jenkins, and Jira, and supported testing through CI/CD pipelines to enhance application reliability and scalability. </p>
      <ul>
  <li>I worked on a high-impact project at OCBC Bank, where I was involved in redesigning and developing the OCBC Bank Internal Application—also known as the GM Workbench Bank Trading DeFi Blockchain Dashboard.</li>
  <li>This project focused on modernizing the bank’s treasury products trading platform, incorporating cutting-edge technologies like decentralized finance (DeFi) and blockchain to track on-chain transactions and provide real-time financial data visualization for a wide range of banking products.</li>
  <li>The application was a critical part of OCBC Bank's internal operations, enabling financial analysts, traders, and decision-makers to monitor and manage complex financial products such as:
  <strong>Treasury Bills, Foreign Exchange (FX), Interest Rate Swaps (IRS), Futures, Options, Credit Default Swaps (CDS), And more...</strong>

  </li>
  <li>My role involved designing and building a responsive, user-friendly interface that could efficiently handle diverse types of data and provide real-time updates for these complex financial transactions.</li>
  <li>I worked closely with the Java-based microservices backend, integrating data seamlessly between the backend and frontend to ensure high performance and reliability.</li>
  <li>One of my key achievements was streamlining the development process using tools like:
    <strong>Bitbucket,Jenkins,Jira</strong>
  </li>
  <li>This allowed for smooth version control and effective collaboration within the development team.</li>
  <li>Additionally, I implemented robust CI/CD pipelines, ensuring that the application was thoroughly tested and could be deployed reliably to production.</li>
  <li>This project played a key role in enhancing the bank's ability to manage and visualize critical financial data, giving them the insights needed to make quick, informed decisions and stay ahead in the rapidly evolving world of financial technology.</li>
</ul>

      `,
      technologies: [
        "JavaScript",
        "TypeScript",
        "React.js",
        "HTML5",
        "CSS3",
        "SASS",
        "SCSS",
        "Webpack",
        "NPM",
        "Material-UI",
        "Microfrontend",
        "Node.js",
        "WebSockets",
        "Web APIs",
        "JWT",
        "Redux",
        "GraphQL",
        "RESTful APIs",
        "Responsive Design",
        "Cross-Browser Compatibility",
        "CSS Grid",
        "Flexbox",
        "React Hooks",
        "Styled-Components",
        "Jest",
        "Cypress",
        "Postman",
        "JSON",
        "AJAX",
        "Axios",
        "Java",
        "Spring Boot",
        "AWS",
        "CI/CD",
        "Jenkins",
        "Git",
        "GitLab",
        "GitHub",
        "Docker",
        "Azure",
        "Lambda",
        "EKS",
        "ECR",
        "Bitbucket",
        "Jira",
        "Agile",
        "Scrum",
        "Blockchain",
        "DeFi",
        "Smart Contracts",
        "UAT",
        "SIT",
        "Functional Design",
        "Frontend Design",
        "Backend Integration",
        "AWS Cloud",
        "Nexus",
        "SonarQube",
        "Microservices",
        "Code Reviews",
        "Code Quality",
        "Team Leadership",
        "Offshore Collaboration",
        "Technical Documentation",
      ],
      usedModules: ["Microfrontend", "Node.js", "React.js", "Jenkins", "CI/CD"],
      live: "",
      source: "",
      image: "mock2",
      imagesUrl: [
        "/assests/img/projects/ocbc/2.jpeg",
        "/assests/img/projects/ocbc/1.jpeg",
        "/assests/img/projects/ocbc/3.jpeg",
        "/assests/img/projects/ocbc/4.jpeg",
      ],
    },
    {
      id: 2,
      title: "Eshop 2.0 Multi-vendor e-commerce application (Singtel)",
      summery: `
      
      <p>This multi-vendor e-commerce application supports online sales of mobile data plans, devices, and accessories across the world. I am specifically involved in developing, maintaining, optimizing performance, and SEO optimization, Security of the React based frontend application, the purchasing section includes newline, add-ons, number share, phones, and accessories, while the managing services section encompasses recontract, SIM activation, checking eligibility, catalog, termination number, changing plans, replacing SIMs, transferring mobile lines, reporting lost, number port, staff eligibility, retrieving eSIM activation, suspending and unsuspending lines, ceasing add-ons, data plans network policy configurations, payment and billing, number reservation, and eSIM activation with QR code. Additionally, I support testing & maintaining the microservices-based backend using .Net, Spring Boot and Node.js with AWS cloud services and CI/CD pipelines.  </p>
      <ul>
      <li>This multi-vendor e-commerce application supports online sales of mobile data plans, devices, and accessories worldwide.</li>
      <li><strong>Key Responsibilities:</strong></li>
      <ul>
        <li>Develop, maintain, and optimize the performance of the React-based frontend application.</li>
        <li>Implement SEO optimization and ensure the security of the frontend application.</li>
        <li>Develop and manage various sections, including:</li>
        <ul>
          <li><strong>Purchasing Section:</strong> Add-ons, number sharing, phones, and accessories.</li>
          <li><strong>Managing Services Section:</strong> Recontracting, SIM activation, eligibility checks, catalog management, number termination, plan changes, SIM replacements, mobile line transfers, lost phone reporting, number porting, staff eligibility verification, eSIM activation retrieval, line suspension and unsuspension, add-on cessation, data plan configurations, network policy settings, payment and billing, number reservation, and QR code-based eSIM activation.</li>
        </ul>
        <li>Support testing and maintain the microservices-based backend using .Net, Spring Boot, and Node.js.</li>
        <li>Utilize AWS cloud services and CI/CD pipelines for deployment and maintenance.</li>
      </ul>
    
      <li><strong>Frontend Technologies:</strong></li>
      <ul>
        <li>HTML5, CSS3, JavaScript (ES6+), TypeScript</li>
        <li>React.js, React Hooks, Next.js, Gatsby.js, AngularJS, Ember.js</li>
        <li>Redux, Redux-Saga, Styled-Components</li>
        <li>GraphQL, Server-Side Rendering (SSR), Static Site Generation (SSG), CDN Optimization</li>
        <li>HTTPS APIs, Jest, Cypress</li>
      </ul>
    
      <li><strong>Backend Technologies:</strong></li>
      <ul>
        <li>Spring Boot, Spring MVC, Spring Security, Spring Data JPA</li>
        <li>RESTful APIs, Microservices Architecture, Dependency Injection</li>
        <li>Thymeleaf, Hibernate, JPA</li>
        <li>MySQL, PostgreSQL, MongoDB</li>
        <li>JWT Authentication, Docker, Kubernetes</li>
        <li>Apache Kafka, RabbitMQ, Swagger/OpenAPI</li>
        <li>JUnit, Mockito, TestNG</li>
        <li>Maven, Gradle, SonarQube</li>
        <li>Reactive Programming (Spring WebFlux), WebClient, RestTemplate</li>
        <li>SSL & Client Certificate Management, Encryption/Decryption</li>
        <li>Actuator, Service Layer, Repository Pattern, Lombok, Validation, Security</li>
      </ul>
    
      <li><strong>AWS & DevOps:</strong></li>
      <ul>
        <li>AWS EKS, S3, ECR, EC2, Lambda, AWS Fargate</li>
        <li>CloudWatch Logging, AWS Secrets Manager</li>
        <li>Code Pipeline, Code Deploy, IAM</li>
        <li>CI/CD: Bamboo CI/CD, Helm Charts, Sonar, Nexus</li>
      </ul>
    
      <li><strong>Other Skills:</strong></li>
      <ul>
        <li>Team Management, Agile Methodologies, Web Application Development</li>
        <li>RESTful APIs Integration, Micro Frontend Architecture</li>
        <li>Charts UIs, Database Management</li>
        <li>.NET Framework, Node.js, Java</li>
      </ul>
    </ul>
    
`,
      technologies: [
        "JavaScript",
        "TypeScript",
        "Webpack",
        "React.js",
        "Nextjs",
        "Gatsbyjs",
        "Nodejs",
        "HTML5",
        "CSS3",
        "SASS",
        "SCSS",
        "LESS",
        "Styled-Components",
        "MaterialUI",
        "Jest",
        "Cypress",
        "SSR",
        "SCR",
        "SSG",
        "Postman",
        "Java",
        ".Net",
        "Spring Boot Reactor",
        "Spring",
        "JPA",
        "Springboot",
        "Security",
        "Restful",
        "Axios",
        "PostgreSQL",
        "MySQL",
        "DynamoDB",
        "Microservices",
        "AWS",
        "CI/CD",
        "Bamboo",
        "Helm",
        "Git",
        "Jira",
        "Lambda",
        "EKS",
        "ECR",
        "Docker",
        "Microservices",
        "i18N",
        "Microfrontend",
        "Webpack",
        "npm",
        "eslint",
        "Helm Chart",
        "Blazor",
        "Forms",
        "SignalR",
      ],
      usedModules: ["React.js", "AWS", "Microservices", "Docker"],
      live: "",
      source: "",
      image: "mock2",
      imagesUrl: [
        "/assests/img/projects/singtel/1.png",
        "/assests/img/projects/singtel/2.png",
        "/assests/img/projects/singtel/3.png",
      ],
    },
    {
      id: 3,
      title: "Mobile Quotation Generation (MQE) (Singtel)",
      summery: `
      <p>Mobile Quotation Generation project, where the primary goal was to develop and maintain a comprehensive mobile application that allows users to generate quotations on the go. This application was designed to streamline the quotation process, making it efficient and user-friendly. I worked on User Authentication and Authorization, Quotation Generation, Quotation Management, Customer and Product Management, Notifications and Alerts, Reporting and Analytics, Integration with Backend Services, Offline Mode, User Interface and Experience, Security and Compliance.
</p?
      <ul>
      <ul>
</ul>
  <ul>
  <ul>
    <li> React (Next.js) Frontend and Node.js Backend based application developed and maintained a mobile application to simplify and streamline quotation generation for mobile services.</li>
    <li>Designed and implemented a user-friendly platform that allowed users to generate mobile service quotes quickly and efficiently.</li>
     <ul> <li><strong>Frontend Technologies:</strong> I have strong expertise in <strong>HTML5, CSS3, JavaScript (ES6+), TypeScript</strong>, along with modern frameworks like <strong>React.js, React Hooks, Next.js, Gatsby.js</strong>, and <strong>Redux</strong>, enabling the development of scalable and responsive user interfaces.</li> <li><strong>Backend Technologies:</strong> I am proficient in <strong>Node.js, Express.js, RESTful APIs</strong>, and building <strong>Microservices Architectures</strong>, with strong experience in managing <strong>JWT Authentication, Docker</strong>, and cloud-based solutions like <strong>AWS</strong>.</li> <li><strong>AWS & DevOps:</strong> I have hands-on experience with <strong>AWS services</strong> like <strong>EC2, Lambda, S3, and EKS</strong>, and expertise in implementing <strong>CI/CD pipelines</strong> with tools such as <strong>Bamboo CI/CD, Helm Charts</strong>, and <strong>AWS Fargate</strong>.</li> <li><strong>Other Skills:</strong> In addition to technical expertise, I bring strong <strong>team management</strong> and <strong>Agile methodologies</strong> experience, and am skilled in <strong>RESTful APIs integration</strong> and <strong>database management</strong>, ensuring seamless project delivery.</li> </ul>

    <li>Contributed to the development of key features, including:</li>
    <ul>
     <li><strong>User Authentication & Authorization:</strong> Implemented secure login and role-based access control.</li>
          <li><strong>Quotation Generation:</strong> Enabled users to create and manage mobile service quotations seamlessly.</li>
          <li><strong>Quotation Management:</strong> Provided tools for tracking, editing, and sharing generated quotations.</li>
          <li><strong>Multi-Vendor Integration:</strong> Integrated multiple mobile service providers for generating quotes from various sources.</li>
          <li><strong>Dynamic Pricing:</strong> Implemented pricing mechanisms that adjust quotes based on vendor, location, and request time.</li>
          <li><strong>Customizable Plans:</strong> Allowed users to create personalized mobile service plans by selecting data, voice, and add-ons from different vendors.</li>
          <li><strong>Real-Time Price Comparison:</strong> Provided real-time comparisons between mobile vendors to aid purchasing decisions.</li>
          <li><strong>Integration with Payment Gateways:</strong> Integrated secure payment gateways for direct payment of generated quotations.</li>
          <li><strong>Quotation Expiry Management:</strong> Allowed setting expiry dates for quotations, prompting user action before expiration.</li>
          <li><strong>Customer Feedback & Rating:</strong> Enabled customers to rate services and provide feedback on quotations.</li>
          <li><strong>Automatic Quote Updates:</strong> Implemented auto-updating of quotations based on vendor pricing changes.</li>
          <li><strong>Vendor Dashboard:</strong> Created a dashboard for vendors to manage offerings, update prices, and monitor quotation generation.</li>
          <li><strong>Quote History and Analytics:</strong> Enabled users to access past quotations for future reference and tracking.</li>
          <li><strong>Notification System:</strong> Integrated notifications to alert users about updates and quote expirations.</li>
          <li><strong>Multi-Language & Currency Support:</strong> Added support for various languages and currencies for global accessibility.</li>
          <li><strong>Quote Sharing and Collaboration:</strong> Allowed users to share quotations with other stakeholders for collaborative decision-making.</li>
          <li><strong>Advanced Search & Filtering:</strong> Implemented search and filter functionality to quickly find the best plans and services.</li>
          <li><strong>Automated Customer Notifications:</strong> Sent automated notifications via email/SMS when quotations are generated or updated.</li>
          <li><strong>Data Import/Export:</strong> Allowed for easy import/export of quotation data for analysis and record-keeping.</li>
          <li><strong>AI-Powered Recommendations:</strong> Integrated AI algorithms to suggest personalized plans based on user preferences.</li>
          <li><strong>Customer & Product Management:</strong> Integrated customer details and mobile product management modules.</li>
          <li><strong>Offline Mode Support:</strong> Implemented offline functionality for users to access and generate quotations without an internet connection.</li>
          <li><strong>Enhanced UI/UX:</strong> Focused on building a mobile app that was intuitive, responsive, and easy to navigate.</li>
          <li><strong>Security & Compliance:</strong> Ensured robust security protocols to meet regulatory standards.</li>
          <li><strong>Performance Optimization:</strong> Ensured the app performed smoothly even when handling large datasets.</li>
         </ul>
    <li>Played a key role in meeting business objectives by ensuring a seamless user experience and regulatory compliance.</li>
  
    </ul>
   </ul>


  </ul>
`,
      technologies: [
        "HTML5",
        "CSS3",
        "JavaScript ES6",
        "TypeScript",
        "Ember.js",
        "React Hooks",
        "Gatsby",
        "Server-Side Rendering",
        "CDN",
        "GraphQL",
        "Static Rendering",
        "Styled-Components",
        "Redux-SAGA",
        "AWS EKS",
        "S3",
        "ECR",
        "CloudWatch Logging",
        "Lambda",
        "AWS Secret Manager",
        "EC2",
        "CodePipeline",
        "CodeDeploy",
        "IAM",
        "Jira",
        "Bamboo CI/CD",
        "Nexus Repository",
        "Sonar Code testing",
        "Fortify scanning",
        "Helm Chart",
        "Bitbucket",
        "Docker",
        "Node.js",
        "Express.js",
        "RESTful APIs",
        "Middleware",
        "JWT Authentication",
        "WebSocket",
        "Error Handling",
        "Async/Await",
        "Promises",
        "Webpack",
        "Babel",
        "ESLint",
        "Nodemon",
        "Jest",
        "Postgresql",
        "DynamoDB",
        "Microservices Architecture",
      ],
      usedModules: [
        "React.js",
        "Node.js",
        "AWS",
        "Microservices",
        "Docker",
        "GraphQL",
      ],
      live: "https://www.singtel.com/",
      source: "",
      image: "mock2",
      imagesUrl: [
        "/assests/img/projects/singtel/1.png",
        "/assests/img/projects/singtel/2.png",
        "/assests/img/projects/singtel/3.png",
      ],
    },
    {
      id: 7,
      title: "DLS NPM Library (Stabilized UI Components) Singtel",
      summery: `<ul>
      <li>Developed an internal UI component library for Singtel to standardize and stabilize UI elements across web applications.</li>
      <li>Created reusable, customizable, and consistent components to improve the efficiency and maintainability of frontend development.</li>
      <li>Collaborated closely with the frontend team to ensure the library met all usability and functionality requirements.</li>
      <li>Integrated Material UI components and styled them for a consistent look and feel across different applications.</li>
      <li>Maintained the library by fixing bugs, optimizing performance, and adding new components based on team requirements.</li>
      <li>Utilized TypeScript for improved type safety and code maintainability.</li>
      <li>Created documentation and example usage for developers to easily integrate and use the components in projects.</li>
      <li>Worked with React hooks, Redux, and other React-related technologies to ensure the components were flexible and performant.</li>
      <li>Ensured cross-browser compatibility and responsive design for all components.</li>
    </ul>`,
      technologies: [
        "React",
        "TypeScript",
        "NPM",
        "CSS Modules",
        "Storybook",
        "Material UI",
        "React Hooks",
        "React Router",
        "Jest",
        "Enzyme",
        "Redux",
      ],
      usedModules: [
        "Button",
        "Input",
        "Modal",
        "Table",
        "Dropdown",
        "AppBar",
        "Typography",
        "Grid",
        "Card",
        "Dialog",
        "Snackbar",
        "Accordion",
      ],
      live: "",
      source: "",
      image: "mock2",
      imagesUrl: [],
    },
    {
      id: 3,
      title:
        "ReactJs Multi Functional Dashboard  (Veritas Petroleum Services USA) (Natobotics)",
      summery: `
      <p>The Veritas Petroleum Customer Portal(2021): ReactJs based Dashboard offers a user-friendly platform to easily provide and manage vessel/ship data from around the world. Developed in this application main features as signin,signup, global filters, vessel reports, assets, vessels/ships scheduler, bunker master and fuel/lube/transformers analysis using modern ReactJs material components.</p>
      <ul>
        <li>
        <strong>Key Features Implemented:</strong>
        <ul>
<ul>
  <li><strong>User Authentication and Management:</strong> Sign-in, sign-up, sign-out, password reset, and role-based access control for customers and administrators.</li>
  <li><strong>Global Filters:</strong> Tools to refine data views and reports based on specific parameters.</li>
  <li><strong>Vessel Reports and Scheduling:</strong> Monitoring and management tools for fleet operations.</li>
  <li><strong>Asset Management:</strong> Tracking and maintenance functionalities for vessel-related assets.</li>
  <li><strong>Bunker Master Module:</strong> Oversight of fuel procurement and consumption.</li>
  <li><strong>Fuel, Lube, and Transformer Analysis:</strong> Tools ensuring optimal performance and compliance.</li>
  <li><strong>Secure Access to Fuel Quality Testing Reports:</strong> Including Fuel Quality Testing, Fuel System Check, Bunker Quality Survey, and Oil Condition Monitoring.</li>
  <li><strong>Advanced Search and Filtering:</strong> Ability to search and filter reports based on criteria such as vessel name, fuel type, port, report status, and outcome.</li>
  <li><strong>Bunker Alerts Archive:</strong> Access to timely information on fuel-related issues.</li>
  <li><strong>Push Notifications for Bunker Alerts:</strong> Keeping users informed of critical updates.</li>
  <li><strong>Integration with Samplogic:</strong> Creating pickup requests and tracking sample shipments.</li>
  <li><strong>Comprehensive Knowledge Center:</strong> Offering news, articles, events, and technical guidance papers.</li>
<li>Pdf reports download and email send to diffrent clients</li>
  </ul>

          </ul>
      </li>
      </ul>`,
      technologies: [
        "Azure",
        "Server-Side Rendering (SSR)",
        "Static Site Generation (SSG)",
        "javascript",
        "@material-ui/core",
        "axios",
        "typescrite",
        "mui-datatables",
        "mathjax-react",
        "material-tabs",
        "react-pdf",
        "react-google-charts",
        "chart.js",
        "js-file-downloader",
        "react-equation",
        "react-date-range",
        "git",
        "redux",
        "react-pro-sidebar",
        "react-redux",
        "react-resizable",

        "react-tinder-card",
        "react-simple-maps",
        "react-select-async-paginate",
        "react-select",
        "react-image-gallery",
        "JSX",
        "Styled Components",
        "Material-UI",
        "Figma",
        "React",
        "Redux",
        "JavaScript",
        "Azure",
        "Git CI/CD",
        "Jenkins",
        "SQL",
        "Charts",
        "Jest",
        "npm",
        "Webpack",
        "Server-Side Rendering (SSR)",
        "Static Site Generation (SSG)",
      ],
      usedModules: [
        "canvasjs",
        "atob",
        "qrcode.react",
        "AWS",
        "react-blink-text",
        "html5",
        "react-bootstrap-table-next",
        "figma",
        "mathjax-react",
        "@date-io/moment",
        "@fortawesome/react-fontawesome",
        "bootstrap",
        "html5",
        "css3",
        "react-material-ui-carouse",
        "recharts",
        "react-tooltip",
        "react-virtualized",
        "react-toastify",
      ],
      live: "https://vpscpdev.z6.web.core.windows.net",
      source: "",
      image: mock2,
      imagesUrl: [
        "/assests/img/projects/natobotics/v/20.PNG",
        "/assests/img/projects/natobotics/v/6.jpeg",
        "/assests/img/projects/natobotics/v/5.webp",
          "/assests/img/projects/natobotics/v/2.png",
          "/assests/img/projects/natobotics/v/3.png",
          "/assests/img/projects/natobotics/v/4.png",
          "/assests/img/projects/natobotics/v/5.png",
          "/assests/img/projects/natobotics/v/6.png",
          "/assests/img/projects/natobotics/v/7.png",
          "/assests/img/projects/natobotics/v/8.png",
          "/assests/img/projects/natobotics/v/9.png",
          "/assests/img/projects/natobotics/v/10.png",
         "/assests/img/projects/natobotics/v/11.PNG",
  "/assests/img/projects/natobotics/v/12.PNG",
  "/assests/img/projects/natobotics/v/13.PNG",
  "/assests/img/projects/natobotics/v/14.PNG",
  "/assests/img/projects/natobotics/v/15.PNG",
  "/assests/img/projects/natobotics/v/16.PNG",
  "/assests/img/projects/natobotics/v/17.PNG",
  "/assests/img/projects/natobotics/v/18.PNG",
  "/assests/img/projects/natobotics/v/19.PNG",
  "/assests/img/projects/natobotics/v/20.PNG",
  "/assests/img/projects/natobotics/v/21.PNG",
  "/assests/img/projects/natobotics/v/22.PNG",
  "/assests/img/projects/natobotics/v/23.PNG",
  "/assests/img/projects/natobotics/v/24.PNG",
  "/assests/img/projects/natobotics/v/25.PNG",
  "/assests/img/projects/natobotics/v/26.PNG",
  "/assests/img/projects/natobotics/v/27.PNG"
      ],
    },
    {
      id: 1,
      title:
        "The BeatsHealth.com - Hospital Management & Healthcare Consulting System (Natobotics)",
      summery: `<ul>
      <li>Beats Health is focused on transforming healthcare practices into a Smart practice that delivers high-value services in a patient-centric setting through continuous innovation.</li>
      <li>The platform improves the efficiency of clinical workflows, significantly reducing the administrative burden for healthcare providers.</li>
      <li>It brings healthcare providers and patients together on the same platform, enabling them to collaborate closely.</li>
      <li>Contributed to the development of both static and dynamic dashboard applications to enhance user experience and streamline operations.</li>
      <li>Developed and maintained responsive user interfaces using React, HTML5, SASS, and MaterialUI for a modern, user-friendly design.</li>
      <li>Used Azure for cloud integration, CI/CD pipelines, and deployment processes to ensure smooth delivery and scalability of the platform.</li>
      <li>Worked with ASP.NET Core, MVC, Razor Pages, and RESTful APIs to build backend services and ensure smooth communication between frontend and backend systems.</li>
      <li>Implemented security features using ASP.NET Core Identity with JWT for secure user authentication and authorization.</li>
      <li>Collaborated with cross-functional teams, managing version control and continuous integration through Git, GitLab, and Azure DevOps.</li>
      <li>Utilized Entity Framework Core and SQL Server to manage and interact with the platform's data, ensuring data integrity and scalability.</li>
      <li>Designed and implemented Blazor components and used WPF/Windows Forms for desktop applications and SignalR for real-time communication.</li>
      <li>Worked with microservices architecture, ensuring scalability and modularity of the platform, leveraging Dependency Injection for clean code and maintainability.</li>
      <li>Applied Singleton Pattern for managing shared resources and used LINQ for data manipulation and querying.</li>
      <li>Use Case 1: Developed a telemedicine feature enabling patients to have remote consultations with healthcare providers, reducing wait times and improving accessibility.</li>
      <li>Use Case 2: Integrated appointment scheduling and reminder systems, reducing no-show rates and improving overall clinic efficiency.</li>
      <li>Use Case 3: Implemented real-time patient monitoring features, where healthcare providers could track patient vitals and health metrics remotely.</li>
      <li>Use Case 4: Developed a digital prescription feature allowing healthcare providers to write, send, and manage prescriptions securely, reducing administrative tasks for both patients and providers.</li>
      <li>Use Case 5: Created a patient feedback system for healthcare providers to gather insights, improving service quality and patient satisfaction.</li>
    </ul>"`,
      technologies: [
        "react",
        "javascript",
        "@mui/Material Design",
        "@material-ui",
        "axios",
        "REST Service",
        "react-time-picker",
        "react-select",
        "react-phone-input-2",
        "react-toastify",
        "react-modal",
        "material-table",
        "react-collapsible",
        "react-base64-downloader",
        "git",
        "github",
        "bootstrap",
        "html5",
        "css3",
        "figma",
        ".net",
        "c#",
        "Pdf downloads",
      ],
      usedModules: ["date-fns", "responsive", "aws sdk", "sass"],
      live: "https://www.thebeatshealth.com/", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
      source: "", // this should be a link to the **repository** of the project, where the code is hosted.
      image: mock1,
      imagesUrl: [
       "/assests/img/projects/natobotics/b/2.png",
  "/assests/img/projects/natobotics/b/3.png",
  "/assests/img/projects/natobotics/b/4.PNG",
  "/assests/img/projects/natobotics/b/5.PNG",
  "/assests/img/projects/natobotics/b/6.PNG",
  "/assests/img/projects/natobotics/b/7.PNG",
  "/assests/img/projects/natobotics/b/8.PNG",
  "/assests/img/projects/natobotics/b/9.PNG",
  "/assests/img/projects/natobotics/b/10.PNG",
      ],
    },
    {
      id: 2,
      title: "Veritas Petroleum Services Static Web Site (Natobotics)",
      summery:
        "This Project for Veritas Petroleum Services(vps). They do world wide OIL testing and report generation.",
      technologies: [
        "javascript",
        "Html",
        "Jquery",
        "github",
        "bootstrap",
        "SEO",
        "Pdf downloads",
        "charts",
        "Maps",
      ],
      usedModules: [],
      live: "https://www.vpsveritas.com",
      source: "",
      image: mock2,
      imagesUrl: [
        "/assests/img/projects/natobotics/v/3.png",
        "/assests/img/projects/natobotics/v/2.png",
        "/assests/img/projects/natobotics/v/1.png",
      ],
    },

    {
      id: 5,
      title:
        "Sales Play - Ecommerce Point of Sale and Inventory Management Application (Nvision) ",
      summery:
        `<ul>
  <li><strong>POS Application Development:</strong> Spearheaded the design and implementation of a comprehensive Point-of-Sale (POS) system, enhancing sales processes and operational efficiency for retail clients.</li>
  <li><strong>Multi-Payment Integration:</strong> Engineered seamless integration with various payment gateways, supporting diverse payment methods and improving transaction flexibility for users.</li>
  <li><strong>E-commerce Platform Synchronization:</strong> Developed robust features to synchronize POS data with e-commerce platforms, ensuring real-time inventory updates and consistent product information across sales channels.</li>
  <li><strong>Intuitive User Interface Design:</strong> Led the creation of user-friendly interfaces using Android Studio and Material Design principles, resulting in enhanced user satisfaction and reduced training time for staff.</li>
  <li><strong>Data Security Implementation:</strong> Implemented advanced security protocols, including data encryption and secure authentication mechanisms, safeguarding sensitive business and customer information.</li>
  <li><strong>Performance Optimization:</strong> Conducted thorough performance tuning and optimization, reducing application load times by 30% and ensuring smooth operation even during peak usage periods.</li>
  <li><strong>Team Collaboration and Leadership:</strong> Collaborated closely with cross-functional teams, providing mentorship to junior developers and ensuring adherence to best coding practices and project timelines.</li>
  <li><strong>Continuous Integration and Deployment:</strong> Utilized Git for version control and established CI/CD pipelines, streamlining the development process and ensuring consistent delivery of application updates.</li>
  <li><strong>Database Management:</strong> Designed and maintained efficient SQLite databases, optimizing data retrieval and storage processes to support the application's scalability and reliability.</li>
  <li><strong>API Integration Expertise:</strong> Integrated Retrofit REST APIs to connect the application with external services, enhancing functionality and providing users with a seamless experience.</li>
  <li><strong>Cross-Platform Development Skills:</strong> Applied knowledge of PHP and MySQL to develop backend services, ensuring seamless data exchange between the mobile application and web platforms.</li>
  <li><strong>Local Storage Solutions:</strong> Implemented IndexedDB and local storage strategies to enable offline data access and synchronization, enhancing usability in low-connectivity environments.</li>
  <li><strong>Security Best Practices:</strong> Utilized JSON Web Tokens (JWT) for secure user authentication, ensuring that only authorized personnel have access to sensitive application features.</li>
</ul>

<ul>
  <li>
    <strong>Point of Sale</strong>
    <ul>
      <li>Developed a comprehensive Point of Sale system to streamline sales operations.</li>
      <li>Enabled seamless sales processing through both Android and web platforms.</li>
      <li>Integrated support for multiple payment methods, including cash and card transactions.</li>
      <li>Implemented functionality to save and manage pending bills until customers are ready to settle.</li>
      <li>Provided options to issue printed or email receipts based on customer preference.</li>
      <li>Integrated receipt printers, barcode scanners, and cash drawers for comprehensive hardware support.</li>
      <li>Implemented features to share receipt details via email or WhatsApp for customer convenience.</li>
      <li>Developed pricing and discount scheduling tools for products and seasonal promotions.</li>
      <li>Ensured offline functionality to allow sales recording without an active internet connection.</li>
      <li>Integrated barcode scanning capabilities to expedite the checkout process.</li>
      <li>Developed a customer display feature to show order details during billing.</li>
      <li>Created categories and sub-categories for organized product or service management.</li>
      <li>Implemented cash management tools to maintain transparency in drawer transactions.</li>
      <li>Added refund processing capabilities applicable across various locations.</li>
      <li>Developed a dashboard application to monitor real-time sales and stock levels.</li>
    </ul>
  </li>
  <li>
    <strong>Shop and Location Management</strong>
    <ul>
      <li>Facilitated the addition of new shops and managed sales, stocks, employees, and customers across different businesses.</li>
      <li>Enabled filtering of reports and analytics on a per-shop basis.</li>
      <li>Allowed customization of receipt designs and other settings unique to each shop.</li>
      <li>Managed all shop operations through an online platform.</li>
      <li>Added new locations to existing or newly created shops with distinct settings.</li>
      <li>Managed unique selling products across different shops.</li>
      <li>Created user accounts for different shops with specific access permissions.</li>
      <li>Tracked product movement and generated sales summary reports for each shop.</li>
    </ul>
  </li>
  <li>
    <strong>Team and Employee Management</strong>
    <ul>
      <li>Identified top-performing employees by tracking individual sales metrics.</li>
      <li>Managed petty cash transactions directly from the Point of Sale system.</li>
      <li>Enabled shift management to reduce employee manipulations and errors.</li>
      <li>Integrated cash drawer functionalities to assist employees in managing cash.</li>
      <li>Created users with different access rights and assigned them to specific shops.</li>
      <li>Automated the calculation of sales commissions.</li>
      <li>Provided access using a PIN option for each employee.</li>
      <li>Offered visibility of staff appointment schedules in a calendar for service-based businesses.</li>
    </ul>
  </li>
  <li>
    <strong>Inventory Management</strong>
    <ul>
      <li>Implemented centralized inventory to manage stock across multiple shops and businesses.</li>
      <li>Developed purchase order functionalities, including raising POs, accepting GRNs, and sharing POs with suppliers.</li>
      <li>Enabled transfer of goods between shops to distribute inventory effectively.</li>
      <li>Allowed viewing and adjustment of stock levels through stock adjustments to rectify discrepancies.</li>
      <li>Provided real-time tracking of stocks and managed multiple inventory-based actions.</li>
      <li>Facilitated importing products in bulk through file uploads.</li>
      <li>Generated automated low stock and stock expiry alerts.</li>
      <li>Offered inventory history to view the flow of inventory across all shops and locations.</li>
      <li>Sent automated email orders to suppliers and tracked receipts through GRNs.</li>
    </ul>
  </li>
  <li>
    <strong>Reporting and Analytics</strong>
    <ul>
      <li>Designed a dashboard with key data and filtration options.</li>
      <li>Tracked daily sales revenue, net profit, gross profit, and discounts through sales reports.</li>
      <li>Provided insights into the best-performing categories over a period.</li>
      <li>Offered inventory history reports to understand the movement of goods over time in each shop.</li>
      <li>Traced expiry of goods through inventory expiry reports.</li>
      <li>Viewed sales performance in each shop and understood sales trends through shop-wise sales reports.</li>
      <li>Monitored fast-selling products based on product data.</li>
      <li>Analyzed sales volumes product-wise to understand sales trends.</li>
      <li>Provided advanced sales reports, including product-wise receipts, order type-wise sales, and more.</li>
      <li>Accessed credit settlements of customers and full reports of creditors through debtor management reports.</li>
    </ul>
  </li>
  <li>
    <strong>Customer Loyalty and Management</strong>
    <ul>
      <li>Built a customer base with contact details and preferences.</li>
      <li>Recognized customer purchases from any shop in the network.</li>
      <li>Viewed customer buying history to provide better service and plan sales.</li>
      <li>Tracked individual customer visits and shop footfall to understand behavioral patterns.</li>
      <li>Ran a point-based loyalty program to reward repeat purchases.</li>
      <li>Utilized loyalty cards to add or redeem points.</li>
      <li>Added important notes about customers and their preferences.</li>
    </ul>
  </li>
  <li>
    <strong>Credit Sales and Debtor Management</strong>
    <ul>
      <li>Maintained debtor profiles, payment cycles, and accepted settlements.</li>
      <li>Viewed the percentage of settlements on the total outstanding balance for each customer and payment type.</li>
    </ul>
  </li>
  <li>
    <strong>Restaurant POS Features</strong>
    <ul>
      <li>Managed orders efficiently and kept teams in sync.</li>
      <li>Built a loyal base of customers through efficient order management and comprehensive inventory management.</li>
      <li>Took orders via tablet or smartphone and sent them to the kitchen on display or printer.</li>
      <li>Enabled kitchen staff to receive and manage orders with open tickets.</li>
      <li>Assigned tickets to tables in one click using predefined ticket options.</li>
      <li>Managed open tickets by splitting, merging, and moving items.</li>
      <li>Assigned tickets to staff for each task.</li>
      <li>Organized items by categories and customized menu screens to increase order-taking efficiency.</li>
      <li>Added toppings and add-ons to items using modifiers.</li>
      <li>Chose preferred dining options such as “Dine in”, “Takeaway”, “Delivery”, etc.</li>
<li>Accepted orders via tablet or smartphone and sent them to the kitchen through displays or printers
 </ul>
  </ul>
`,
      technologies: [
        "Android",
        "facebook login",
        "play service authentication(GSM)",
        "web view",
        "Android networking",
        "Material Design",
        "Dashboard Management",
        "Payment Gateways ",
        "Multi Role Authentication",
        "Jetpack",
        "API",
        "REST Services",
        "Multi language Support",
        "MySql Database",
        "AWS",
        "clould",
        "Retrofit",
        "Google map",
        "firebase firestore realtime datatbase analytics",
        "Junit",
        "Animation",
        "Room Database",
        "SQLite",
        "JSon",
        "Country/date time picker",
        "js out",
        "Google Play Store",
        "coil image",
        "pdf download",
        "scroller view",
      ],
      usedModules: ["react","Web site", "php", "html", "css", "boostrap", "jquery"],
      live: "https://www.salesplay.com",
      source: "",
      image: mock2,
      imagesUrl: [
        "/assests/img/projects/sp/1.png",
    "assests/img/projects/sp/2.png",
    "assests/img/projects/sp/3.png",
    "assests/img/projects/sp/4.png",
    "assests/img/projects/sp/5.png",
    "assests/img/projects/sp/6.png",
    "assests/img/projects/sp/7.png",
    "assests/img/projects/sp/8.png",
    "assests/img/projects/sp/9.png",
    "assests/img/projects/sp/10.png",
    "assests/img/projects/sp/11.png",
    "assests/img/projects/sp/13.png",
    "assests/img/projects/sp/14.png",
    "assests/img/projects/sp/15.png",
    "assests/img/projects/sp/16.png",
    "assests/img/projects/sp/17.png",
    "assests/img/projects/sp/18.png",
    "assests/img/projects/sp/19.png",
    "assests/img/projects/sp/20.png",
    "assests/img/projects/sp/21.png",
    "assests/img/projects/sp/22.png",
    "assests/img/projects/sp/23.png"],
    },
    {
      id: 6,
      title: "React Native - Sales Play Dashboard app",
      summery:
        "Thsi App for the Nvision Lanka pvt LTD to show their products statistics showing app",
      technologies: [
        "React Native",
        "expo",
        "react-native-screens",
        "react-native-tab-view",
        "android",
        "react-native-paper",
        "react-native-pager-view",
        "ios",
        "react-native-check-box",
        "expo-sqlite",
        "expo-status-bar",
        "react-native-gesture-handler",
      ],
      usedModules: ["expo-file-system", "@expo/vector-icons", "native base"],
      live: "",
      source:
        "https://github.com/savindu-pasintha/react-native-sales-play-dashboard",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/sales%20play%20pos%20dashboard%20app%2F1.jpg?alt=media&token=bbf00f30-b029-48eb-895a-ff4e4a6fc1d5",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/sales%20play%20pos%20dashboard%20app%2F2.jpg?alt=media&token=bc67b3c3-b2d3-48dd-88bc-ed6bb4b74547",
      ],
    },
    {
      id: 6,
      title: "Android Java Ecommerce App (Cup Cake selling)",
      summery:
        "This Android mobile app for selling cupcakes, special occasion cupcakes and all kind of sweets. And also they offer cupcake decoration classes also. It can manage client orders, manage stock and many other benefits included.",
      technologies: [
        "Java",
        "payment gateway",
        "Android",
        "room databse",
        "SqlLite",
        "API Handling",
        "Material Design",
        "Firebase Authetication",
      ],
      usedModules: [
        "com.google.android.material:material",
        "androidx.constraintlayout:constraintlayout",
        "junit",
        "com.github.bumptech.glide:glide",
      ],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-cupCakes-app-ecommerce/tree/main/cupcakeapp",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cupcake%20app%20java%20android%2F5.PNG?alt=media&token=c506d727-cf6d-4c2d-a9d0-290612a72a62",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cupcake%20app%20java%20android%2F1.PNG?alt=media&token=7c443ab5-de1a-4298-ab51-e3ae0c01ef14",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cupcake%20app%20java%20android%2F2.PNG?alt=media&token=5fe14a54-1a5e-4153-927b-ddae9792edc8",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cupcake%20app%20java%20android%2F3.PNG?alt=media&token=7de29bfb-fa5f-404c-8eee-a69af227cb07",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cupcake%20app%20java%20android%2F4.PNG?alt=media&token=17f95094-0e19-4969-8066-9d5f286cbd6f",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cupcake%20app%20java%20android%2F6.PNG?alt=media&token=27ead611-6893-4b27-86de-6f1938a5ec72",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cupcake%20app%20java%20android%2F7.PNG?alt=media&token=234423e3-83fc-462b-9823-1050892fef84",
      ],
    },
    {
      id: 6,
      title: "Android Java `News App`",
      summery:
        "This app based on the java native Android app development. Anyone Can News search and show the all the details about that topic.I used Retrofit library with singleton design pattern for the `newsapi.org` API data access.",

      technologies: [
        "Java",
        "com.squareup.retrofit2:retrofit",
        "Android",
        "swiperefreshlayout:swiperefreshlayout",
        "Android web view",
        "Android Networking",
        "com.google.android.gms:play-services-ads",
        "Singleton pattern",
        "Retrofit Https Request handling",
        "org.ocpsoft.prettytime:prettytime",
        "Android Material Design",
        "com.squareup.retrofit2:converter-gson",
      ],
      usedModules: [
        "News Searching",
        "io.github.medyo:android-about-page",
        "Show Vidios",
        "Show Images",
        "com.squareup.picasso:picasso",
        "commenting",
      ],
      live: "https://github.com/savindu-pasintha/Android-Java-news-app/tree/master/app/release",
      source: "https://github.com/savindu-pasintha/Android-Java-news-app",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/Android%20News%20app%20java%2F2.jpg?alt=media&token=bd6d0de0-defa-4641-85c8-7d968c719c34",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/Android%20News%20app%20java%2F3.jpg?alt=media&token=25ed25f5-82ad-435f-a134-c14c2d7dfa35",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/Android%20News%20app%20java%2F4.jpg?alt=media&token=8f1c2ce0-1747-4768-9f35-5af4c1d89b6f",

        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/Android%20News%20app%20java%2F1.jpg?alt=media&token=f677ed5a-4f08-4320-b39c-dc9769c69c33",
      ],
    },
    {
      id: 6,
      title: "Android Java `Wallpaper changing App`",
      summery:
        "Users can see multiple wallpapers in the screen. when user select one wallpaper he/she can  set as a mobile Lock screen and Home screen wallpaper",
      technologies: [
        "Java",
        "Android",
        "Jet pack",
        "Image hangling",
        "android.material",
        "internet",
        "android.gms:play-services-ads",
        "Retrofit API",
        "com.squareup.retrofit2:retrofit:2.4.0",
        "com.squareup.retrofit2:converter-gson:2.2.0",
        "Picaso for image url com.squareup.picasso:picasso:2.5.0",
        "image url set to image view com.github.bumptech.glide:glide:4.12.0",
      ],
      usedModules: ["Change The mobile phone wallpaper"],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Android-APPS-JAVA/tree/master/WallpaperChangeApp",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/wallpaper%20app%20android%20java%2F1.jpg?alt=media&token=453fe0db-861e-4b24-9a39-7b0ecca059f7",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/wallpaper%20app%20android%20java%2F2.jpg?alt=media&token=b521fbe7-6de5-4d4d-a130-f1560422bdeb",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/wallpaper%20app%20android%20java%2F3.jpg?alt=media&token=1a8253c4-7e6b-4e6e-aaa5-9f8bd6a93867",
      ],
    },
    {
      id: 6,
      title: "Android Java `Whatsapp Status Saving App`",
      summery:
        "This app user to allow , their whatsapp status saving to Mobile phone file Storage.",
      technologies: [
        "Java",
        "Android",
        "Jet pack",
        "Image hangling",
        "android.material",
        "internet",
        "android.gms:play-services-ads",
        "Retrofit API",
        "com.squareup.retrofit2:retrofit:2.4.0",
        "com.squareup.retrofit2:converter-gson:2.2.0",
        "Picaso for image url com.squareup.picasso:picasso:2.5.0",
        "image url set to image view com.github.bumptech.glide:glide:4.12.0",
      ],
      usedModules: [
        "✔️ View WhatsApp stories",
        "✔️ Save WhatsApp stories",
        "✔️ Full Screen Whatsapp Stories view",
        "✔️ Preview Downloaded Story",
        "✔️ Offers WhatsApp status download option",
        "✔️ Share with Friends",
        "✔️ Delete Unwanted Whatsapp Story",
      ],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Android-APPS-JAVA/tree/master/Status-Saver-master",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/whatsapp%20status%20saving%20app%2F2.PNG?alt=media&token=281a1f8b-d611-44e0-b108-ac23ca4aa148",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/whatsapp%20status%20saving%20app%2F1.PNG?alt=media&token=d869e112-37b8-4db8-86a3-201325292ad2",
      ],
    },
    {
      id: 6,
      title: "React Native (Uber Eats Clone App)",
      summery: "This app for React Native sample `uber eats clone`",
      technologies: [
        "React Native",
        "firebase",
        "firestore",
        "authentication",
        "react-native-elements",
        "react-native-reanimated",
        "redux",
        "react-native-vector-icons",
        "react-native-bouncy-checkbox",
        "expo",
        "react-native-screens",
        "react-native-tab-view",
        "android",
        "react-native-paper",
        "react-native-pager-view",
        "ios",
        "react-native-check-box",
        "expo-sqlite",
        "expo-status-bar",
        "react-native-gesture-handler",
      ],
      usedModules: [
        "product search",
        "authentication",
        "screen navigations",
        "google map",
        "cart",
        "buy",
        "messaging",
      ],
      live: "",
      source: "",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/uber%20eats%20%20react%20native%20app%2F1.jpg?alt=media&token=46545e19-e9ef-4ab9-abb1-eae4e78394e8",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/uber%20eats%20%20react%20native%20app%2F3.PNG?alt=media&token=16865925-57bf-46e6-b0a7-4fcd695e2f2e",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/uber%20eats%20%20react%20native%20app%2F5.PNG?alt=media&token=6a908e34-74f4-4691-b56d-1938f01372de",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/uber%20eats%20%20react%20native%20app%2F1.jpg?alt=media&token=46545e19-e9ef-4ab9-abb1-eae4e78394e8",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/uber%20eats%20%20react%20native%20app%2F4.PNG?alt=media&token=d8084aad-1dc5-43ce-9db0-3fd5a299f328",
      ],
    },
    {
      id: 6,
      title: "React JS / Node js Core Ui Dashboard web application",
      summery:
        "This web site for the Dashboard management system with react core Ui. Backend as a used Nodejs.",
      technologies: [
        "props",
        "Nodejs",
        "expressjs",
        "mysql databse",
        "authO2",
        "core ui template",
        "react",
        "javascript",
        "@mui/Material Design",
        "@material-ui",
        "axios",
        "REST Service",
        "react-time-picker",
        "react-select",
        "react-phone-input-2",
        "react-toastify",
        "react-modal",
        "material-table",
        "react-collapsible",
        "react-base64-downloader",
        "git",
        "github",
        "bootstrap",
        "html5",
        "css3",
        "figma",
        ".net",
        "c#",
        "Pdf downloads",
      ],
      usedModules: [
        "analysis charts",
        "diagrams",
        "date-fns",
        "responsive",
        "aws sdk",
        "sass",
      ],

      live: "",
      source: "https://github.com/savindu-pasintha/vuejs-Core-Ui-Admin-Panel",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/React%20JS%20Node%20js%20Core%20Ui%20Dashboard%20web%20application%2F1.PNG?alt=media&token=af5ca586-2c09-44b4-b257-111863cbf219",
      ],
    },
    {
      id: 6,
      title: "Reactjs `Youtube Clone`",
      summery:
        "A web site allow to Watch Youtube vidios through the Google youtube web API",
      technologies: [
        "google developer API",
        "react",
        "axios",
        "bootstrap",
        "http-proxy-middleware",
        "jquery",
        "popper.js",
        "reactjs-media",
      ],
      usedModules: [""],
      live: "https://youtubesp.netlify.app/",
      source: "https://github.com/savindu-pasintha/youtubeClone",
      image: mock2,
      imagesUrl: [
        "assests/img/projects/y/2.png",
        "assests/img/projects/y/1.png",
        "assests/img/projects/y/3.png"
      ],
    },

    {
      id: 6,
      title: "Thermal-Printing-Software - (USB Supported)",
      summery:
        "Customer to have fully Freedom to Customize Printing Template any of items. \n Who Can For this : Any kind of Thermal Reciept printing solution you want , you can use this. (ex : sales , shop , market , wholesale ..). You Can connect your : Desktop , Laptop ... In the future, I hope to develop this for remote access your Thermal printer. Tested with ESC(POS) Printers. MultiLang Supported.(Stil Testing with Percian Languages)",
      technologies: [
        "ESC(pos) COMMANDS",
        "c# language",
        "C# web sockets",
        ".net framework",
        "Desktop application",
        "thermal printers",
        "pc Hardware access",
        "API hanlding",
        "muti language supporting",
        "html",
        "css",
        "javascript",
      ],
      usedModules: ["data encoding", "decoding", "printers access"],
      live: "https://github.com/savindu-pasintha/Thermal-Printing-Software-Solution-USB-Supported-/blob/main/README.md",
      source:
        "https://github.com/savindu-pasintha/Thermal-Printing-Software-Solution-USB-Supported-/blob/main/README.md",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/Thermal%20printer%20c%23%2FDESCRIPTION.PNG?alt=media&token=dfa10043-7978-4058-90c2-8371051167bb",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/Thermal%20printer%20c%23%2FWhatsApp%20Image%202022-08-23%20at%2010.33.00%20AM.jpeg?alt=media&token=43509890-9f01-45ba-8459-d72ebe0f0938",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/Thermal%20printer%20c%23%2Fprint%20image.jpg?alt=media&token=a6f3169e-c8d9-4b06-976c-57177b177d85",
      ],
    },
    {
      id: 6,
      title: "Cheap Resto` React + Nodejs + Machin Learning + Mysql + GraphQL",
      summery: "",
      technologies: [
        "React Js, react bootstraps and other react materials and components.",
      ],
      usedModules: [
        "Cheap Resto",
        "Finding Restaurant",
        "Artificial Intelligence Based Restaurants Filter/Search",
        "Top Restaurants at near you.",
      ],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2F1.png?alt=media&token=73871172-5c25-4659-97f1-dcfacb5fe3d9",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2F2.png?alt=media&token=80f49b2d-0178-4e6a-8b01-02c55bbbdadf",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2F3.png?alt=media&token=34c31882-d89e-43f6-a2bb-1e0845c4c999",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2F4.png?alt=media&token=5e4fdd41-4d4d-4ce7-b648-2c61a49a8563",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2F5.png?alt=media&token=2884ff7f-7b78-43f2-a344-90db8061dd8c",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2F6.png?alt=media&token=ff70ac48-7bde-4f3b-881d-bbb934f81a82",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2F6.png?alt=media&token=ff70ac48-7bde-4f3b-881d-bbb934f81a82",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2FCheapresto%20SAD.drawio%20(1).png?alt=media&token=6f3431b2-f020-48c4-952f-564eb52fc15d",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2FER%20Database%20Diagram.jpg?alt=media&token=55af7a38-1229-4973-906f-027ab51755b7",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2FRestaurant%20Filtering%20Flow.drawio%20(1).png?alt=media&token=75bc47bb-810c-431f-864e-0980ab1caf88",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2FSequence%20for%20Ai%20based%20python%20model.jpg?alt=media&token=581d0de5-0fa6-47c9-a4be-18a5a8b222c4",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2FUser%20case%20for%20cheap%20resto.drawio.png?alt=media&token=fb5a7afb-aee3-4196-8471-ac09c70f5008",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2Flogin%20flow%20chart.png?alt=media&token=265f8963-5974-495d-b569-c851acd2fd47",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2Fsign%20in%20sequence.png?alt=media&token=07e96eb3-9eaf-467b-9cf9-524766859f8a",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2Fuser%20registration%20flow%20chart.png?alt=media&token=19fb8717-9b33-44a0-859a-74856b29c262",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/cheap%20resto%20machine%20learning%2Fuser%20registration%20sequence%20diagram.png?alt=media&token=d51498a8-a2aa-446a-87f0-9090755c6dbc",
      ],
    },
    {
      id: 6,
      title: "`Whiteboard Application + Audio + vidio`",
      summery:
        "This web application allows to AWS hosting with janus webRTC Canvas Whiteboard sharing Iearning site for one to one education .",
      technologies: [
        "React",
        "Nodejs",
        "socket.io",
        "websocket",
        "canvas sharing",
        "one to one voice/vidio sharing",
        "janus API",
        "enginX",
        "aws",
        "firebase",
      ],
      usedModules: [""],
      live: "",
      source: "",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/whiteboard%20share%20application%2FWhatsApp%20Image%202022-08-25%20at%206.05.38%20AM%20(1).jpeg?alt=media&token=b4666b53-0f93-4575-a716-1c6468334b38",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/whiteboard%20share%20application%2FWhatsApp%20Image%202022-08-25%20at%206.05.38%20AM%20(1).jpeg?alt=media&token=b4666b53-0f93-4575-a716-1c6468334b38y",
      ],
    },
    {
      id: 6,
      title: "React Js `You Clever` web site for Developers Hiring",
      summery:
        "This web site look like a stack overflow web site. this web site allow to ad questions or problems, special feature is a automatically generate portfolio profile for all the registered developers. we can download that profile pdf and it we can give as a job interview resume.",
      technologies: [
        "javascript",
        "@material-ui/core",
        "firebase",
        "mysql",
        "axios",
        "typescrite",
        "mui-datatables",
        "mathjax-react",
        "material-tabs",
        "react-pdf",
        "react-google-charts",
        "chart.js",
        "js-file-downloader",
        "react-equation",
        "react-date-range",
        "git",
        "redux",
        "react-pro-sidebar",
        "react-redux",
        "react-resizable",
        "node js backend",
        "react-tinder-card",
        "react-simple-maps",
        "react-select-async-paginate",
        "react-select",
        "react-image-gallery",
      ],
      usedModules: [
        "@material-ui/core",
        "firebase",
        "mysql",
        "axios",
        "typescrite",
        "mui-datatables",
        "mathjax-react",
        "material-tabs",
        "react-pdf",
        "react-google-charts",
        "chart.js",
        "js-file-downloader",
      ],
      live: "https://youclever.netlify.app/",
      source: "https://github.com/savindu-pasintha/Youclever-Site-",

      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/You%20clever%20site%2F1.png?alt=media&token=5c65604e-f638-496c-9d62-f27f08bb691c",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/You%20clever%20site%2F2.png?alt=media&token=2e4d2a5b-7c96-449a-8b92-13df37630f6f",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/You%20clever%20site%2F3.png?alt=media&token=c095e8aa-2dff-41a7-8971-deabe7550d14",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/You%20clever%20site%2F4.png?alt=media&token=7a337b01-3825-4610-a7fa-7c75e82e0883",
      ],
    },
    {
      id: 6,
      title: "`Flamesoles.com` WordPress Site for USA Client in Upwork",
      summery:
        "This one is Woocomerce based on WordPress Ecommerce web site for the Shoes Selling . After Creating this, I complete It as a fully SEO website.",
      technologies: [""],
      usedModules: [""],
      live: "https://flamesoles.com",
      source: "",
      image: mock2,
      imagesUrl: [
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/flamesole%20wordpress%2F1.png?alt=media&token=8b093bb5-3d3b-4053-8c5e-0eb72d3daa12",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/flamesole%20wordpress%2F2.png?alt=media&token=7313ec34-35ff-4276-bae5-a1ecd445754b",
        "https://firebasestorage.googleapis.com/v0/b/savindupasintha-71dd8.appspot.com/o/flamesole%20wordpress%2F3.png?alt=media&token=c115be18-bb96-422c-943f-c7811a4ce5b5",
      ],
    },
    {
      id: 4,
      title: "QT GUI C++ Desktop Application(China)",
      summery:
        "This Project for the `Elastic Quality Checking Software Solution`",
      technologies: [
        "c++",
        "QT Framework",
        "IOT",
        "QML",
        "CSS",
        "Electric Motors",
        "Camera",
        "Lights",
      ],
      usedModules: [""],
      live: "",
      source: "",
      image: mock2,
      imagesUrl: [""],
    },
    {
      id: 6,
      title: "React Js Portfolio Web Application",
      summery: "A web site allow to view developer portfolio. ",
      technologies: [""],
      usedModules: [""],
      live: "",
      source: "",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "React Js Learning Web Application",
      summery:
        "A web site allow to find students to tuition classes and teachers can register web site.      ",
      technologies: [""],
      usedModules: [""],
      live: "",
      source: "",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "React Js Facemash web Application",
      summery:
        "A web site for when user click on the image s randomly image change .      ",
      technologies: [""],
      usedModules: [""],
      live: "",
      source: "",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "PHP Jewellery Full Ecommerce Web Application",
      summery:
        "A web site for full functional online jewellery selling. All the users can buy the jewellery item and Admin can manage stock.      ",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "Bakery Web Site",
      summery:
        "A web site for full functional online Bakery items selling. All the users can buy bakery items and Admin can manage stock",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "ASP.NET MVC  Web Application For `Hotel Booking System`",
      summery: "A web site for Hotel Reservation .      ",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: " ASP.NET MVC Web Application For `Flower Selling`",
      summery:
        "A web site for full functional flower selling and admin support to manage all the flower stocks and user accounts.",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "`Hospital Management System` Java maven web application for ",
      summery:
        "This is java base web application . To develop this I used Java maven, Soap & Rest Service for complete my diploma program Technology as used Java Maven , JSP , Boostrap , Mysql databse",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "Pyhton Machine Learning System `Restaurant Rating Predict`",
      summery:
        "After the developing this system, I learnt all the necessary machine learning concept using python.To complete this project front end as rest service as a used `FLASK`` .",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },

    {
      id: 6,
      title: "` Book Store` Java Netbean DeskTop Application",
      summery:
        "A Desktop application for Store Book shop Book details. This application allows to Book Store manage with book searching functionalty",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "`Whole sale Order Management System` ",
      summery:
        "A Desktop application for fully automation order management system.",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "`Flower Management System ` C# Desktop Application",
      summery:
        "A Desktop application for fully automation flower selling and management system",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "C++ `Car Rental System`",
      summery:
        "A Desktop Console application for fully automation car rental management system.      ",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "Springboot Backend for `Hospital Management system`",
      summery: "",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "NodeJS/Express  Backend `",
      summery: "",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
    {
      id: 6,
      title: "`Flutter App`",
      summery: "",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },

    {
      id: 6,
      title: "",
      summery: "",
      technologies: [""],
      usedModules: [""],
      live: "",
      source:
        "https://github.com/savindu-pasintha/Java-EE-Hospital-Project-REST-Mysql-with-Jersey",
      image: mock2,
      imagesUrl: [],
    },
  ],
};
